import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import cartoon from '../../Assetes/Images/pickup.png'
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import PickupModal from './PickupModal';
import { connect, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { findPickupStores, saveOrderLaterDateTime, saveOrderTime, saveOrderType, getTimezone, getTimezoneForLater, saveSelectStoreId, storeMenuItemCall, saveCart } from '../../Redux';
import useTrackEvent from '../../hooks/useTrackHook';
import { saveStorePosFee } from '../../Redux/actions/store';
import { useTranslation } from 'react-i18next';
import useCurrentLocale from '../../hooks/useLanguage';

function PickUp(props: any) {
    const orderType = useSelector((state: any) => state.payment.orderType);
    let cartData = useSelector((state: any) => state.cart.cartData)
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const [show, showModal] = useState(false);
    const [orderTime, setOrderTime] = useState("now")
    const [validTimeFlag, setValidTimeFlag] = useState(false);
    const [pickupStore, setPickupStore]: any = useState(null);
    let [laterdatetime, setLaterDate] = useState("")
    const [open, cartShowModal] = useState(false);
    const handleClose = () => showModal(false);
    const [addEvent] = useTrackEvent()
    const lang = useCurrentLocale();
    const pathname = window.location.pathname;
    const handleShow = () => {
        props.findPickupStores(showModal);
    }
    const closeModal = () => {
        showModal(false)
        cartShowModal(false)
    }
    const selectStore = (e: any) => {
        if (!_.isEmpty(e)) {
            let storeData = e;
            setPickupStore(storeData)
        }
    }
    const HoursArray = (hourDiff: any, starttime: any) => {
        if (String(hourDiff).indexOf('-') !== -1) {
            hourDiff = hourDiff + 24;
        }
        var hours: any = [];
        let hour = starttime;
        for (let i = 0; i <= hourDiff; i++) {
            hour = starttime + i;
            let AmOrPm = '';
            hour >= 12 && hour < 24 ? (AmOrPm = 'pm') : (AmOrPm = 'am');
            hour = hour % 12 || 12;
            hours.push(hour + AmOrPm);
        }
        var string = hours.join(':');
        return string;
    };
    const savePickupStore = () => {
        let selectedPickupStore: any = pickupStore;
        props.saveSelectStoreId(selectedPickupStore)
        props.saveOrderType("Pickup")
        props.saveOrderTime(orderTime)
        props.saveStorePosFee(selectedPickupStore.pos_service_fee)
        if (orderTime == "later") {
            props.saveOrderLaterDateTime(laterdatetime)
        } else {
            props.saveOrderLaterDateTime(null)
        }
        props.storeMenuItemCall(selectedPickupStore.store_id, "Pickup",pathname,lang)
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'pickup',
            'ecommerce': {
                'select': {
                    'channel': "pickup"
                }
            }
        });
        closeModal()
        if (props.handleSelectStoreClose) {
            props.handleSelectStoreClose()
        }
    }
    //Later Case
    const compareLaterOpenClosingTime = (storeSelected: any) => {
        props.getTimezoneForLater(storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)
            let dateIndexClient = laterdatetime.indexOf("T")
            let clientDate = laterdatetime.slice(0, dateIndexClient)
            let todayValidDate: any = new Date();
            let t = todayValidDate.getDate()
            let validDate = parseInt(t) == parseInt(serverDate.split("-")[2]) && serverDate.split("-")[0] == clientDate.split("-")[0] && serverDate.split("-")[1] == clientDate.split("-")[1] && (parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]) || parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]))
            if (validDate) {
                let addedTime: any = null;
                let today = new Date();
                let todayHours = today.getHours()

                if (todayHours != parseInt(serverTime.time.split(":")[0])) {
                    toast.error(t("INVALID_DEVICE_TIME"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
                let laterDate = new Date(laterdatetime);
                let futureHours: any = laterDate.getHours();
                let futureMinutes: any = laterDate.getMinutes();

                if (addedTime) {
                    futureHours = addedTime.split(":")[0];
                    futureMinutes = addedTime.split(":")[1];
                }

                let futureAmOrPm = futureHours >= 12 ? 'pm' : 'am';
                futureHours = futureHours % 12 || 12;
                let futuretime: any = futureHours + '' + futureAmOrPm;
                //define hours or minutes
                var timeStartMin = new Date(
                    '01/01/2007 ' + storeSelected.store_open_time,
                ).getMinutes();
                var timeEndMin = new Date(
                    '01/01/2007 ' + storeSelected.store_close_time,
                ).getMinutes();
                var timeStartHours = new Date(
                    '01/01/2007 ' + storeSelected.store_open_time,
                ).getHours();
                var timeEndHours = new Date(
                    '01/01/2007 ' + storeSelected.store_close_time,
                ).getHours();
                var hourDiff: any = timeEndHours - timeStartHours;
                let HourString = HoursArray(hourDiff, timeStartHours);
                let splitHourArray = HourString.split(":")
                if (splitHourArray.indexOf(futuretime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                    if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                        if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                            //if Pick Hour with am/pm is exist in HourString at last index
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.TOP_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        } else {
                            savePickupStore()
                        }
                    } else {
                        if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                            if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                if (futureMinutes < timeEndMin) {
                                    savePickupStore()
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            } else {
                                savePickupStore()
                            }
                        } else { //if store opening or closing minute is not 00
                            if (
                                futureMinutes > timeStartMin ||
                                futureMinutes < timeEndMin
                            ) {
                                savePickupStore()
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.TOP_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        }
                    }
                } else {
                    toast.error(t("STORE_CLOSED"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
            } else {
                toast.error(t("INVALID_DEVICE_TIME"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    const compareLaterTimingbyEachDay = (storeSelected: any) => {
        props.getTimezoneForLater(props.storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)
            let dateIndexClient = laterdatetime.indexOf("T")
            let clientDate = laterdatetime.slice(0, dateIndexClient)
            let todayValidDate: any = new Date();
            let t = todayValidDate.getDate()
            let validDate = parseInt(t) == parseInt(serverDate.split("-")[2]) && serverDate.split("-")[0] == clientDate.split("-")[0] && serverDate.split("-")[1] == clientDate.split("-")[1] && (parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]) || parseInt(serverDate.split("-")[2]) + 1 == parseInt(clientDate.split("-")[2]))
            if (validDate) {
                let today = new Date();
                let todayHours = today.getHours()

                if (todayHours != parseInt(serverTime.time.split(":")[0])) {
                    toast.error(t("INVALID_DEVICE_TIME"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
                let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                let weekDaysTimingArr = JSON.parse(storeSelected.daysTiming)
                let futureDay = new Date(laterdatetime).getDay();
                let dayName = days[futureDay];
                weekDaysTimingArr.map((storeDay: any) => {
                    if (dayName == storeDay.day) {
                        let laterDate = new Date(laterdatetime);
                        let futureHours: any = laterDate.getHours();
                        let futureMinutes: any = laterDate.getMinutes();
                        let futureAmOrPm = futureHours >= 12 ? 'pm' : 'am';
                        futureHours = futureHours % 12 || 12;
                        let futuretime: any = futureHours + '' + futureAmOrPm;
                        //define hours or minutes
                        var timeStartMin = new Date(
                            '01/01/2007 ' + storeDay.opening,
                        ).getMinutes();
                        var timeEndMin = new Date(
                            '01/01/2007 ' + storeDay.closing,
                        ).getMinutes();
                        var timeStartHours = new Date(
                            '01/01/2007 ' + storeDay.opening,
                        ).getHours();
                        var timeEndHours = new Date(
                            '01/01/2007 ' + storeDay.closing,
                        ).getHours();
                        var hourDiff: any = timeEndHours - timeStartHours;
                        let HourString = HoursArray(hourDiff, timeStartHours);
                        let splitHourArray = HourString.split(":")
                        if (splitHourArray.indexOf(futuretime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                            if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                                if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                    //if Pick Hour with am/pm is exist in HourString at last index
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                } else {
                                    savePickupStore()
                                }
                            } else {
                                if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                                    if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                        if (futureMinutes < timeEndMin) {
                                            savePickupStore()
                                        } else {
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.TOP_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    } else {
                                        savePickupStore()
                                    }
                                } else { //if store opening or closing minute is not 00
                                    if (
                                        futureMinutes > timeStartMin ||
                                        futureMinutes < timeEndMin
                                    ) {
                                        savePickupStore()
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.TOP_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                }
                            }
                        } else {
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.TOP_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    }
                })
            } else {
                toast.error(t("INVALID_DEVICE_TIME"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    //Now Case
    const compareOpenClosingTime = (storeSelected: any) => {
        props.getTimezone(storeSelected.store_id).then((serverTime: any) => {
            //convert the current time 24 hour to 12 hour
            let CurrentHours: any = serverTime.split(":")[0];
            let currentMinutes: any = serverTime.split(":")[1];
            let CurrentAmOrPm = CurrentHours >= 12 ? 'pm' : 'am';
            CurrentHours = CurrentHours % 12 || 12;
            let Currenttime: any = CurrentHours + '' + CurrentAmOrPm;
            //define hours or minutes
            var timeStartMin = new Date(
                '01/01/2007 ' + storeSelected.store_open_time,
            ).getMinutes();
            var timeEndMin = new Date(
                '01/01/2007 ' + storeSelected.store_close_time,
            ).getMinutes();
            var timeStartHours = new Date(
                '01/01/2007 ' + storeSelected.store_open_time,
            ).getHours();
            var timeEndHours = new Date(
                '01/01/2007 ' + storeSelected.store_close_time,
            ).getHours();
            var hourDiff: any = timeEndHours - timeStartHours;
            let HourString = HoursArray(hourDiff, timeStartHours);
            let splitHourArray = HourString.split(":")
            if (splitHourArray.indexOf(Currenttime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                    if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                        //if Pick Hour with am/pm is exist in HourString at last index
                        toast.error(t("STORE_CLOSED"), {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                    } else {
                        savePickupStore()
                    }
                } else {
                    if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                        if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                            if (currentMinutes < timeEndMin) {
                                savePickupStore()
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.TOP_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        } else {
                            savePickupStore()
                        }
                    } else { //if store opening or closing minute is not 00
                        if (
                            currentMinutes > timeStartMin ||
                            currentMinutes < timeEndMin
                        ) {
                            savePickupStore()
                        } else {
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.TOP_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    }
                }
            } else {
                toast.error(t("STORE_CLOSED"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    const compareTimingbyEachDay = (storeSelected: any, channel: any) => {
        props.getTimezoneForLater(storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)

            let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let weekDaysTimingArr = JSON.parse(storeSelected.channel_days_timing)
            let todayDay = new Date(serverDate).getDay();
            let dayName = days[todayDay];


            weekDaysTimingArr.map((storeDay: any) => {
                if (dayName == storeDay.day) {
                    let timePeriods = storeDay.timePeriods;
                    let storeOpenTime = null;
                    let storeCloseTime = null;
                    timePeriods.map((period: any) => {
                        if (period.channel == channel) {
                            storeOpenTime = period.opening;
                            storeCloseTime = period.closing;
                        }
                    })
                    let today = new Date();

                    let CurrentHours: any = serverTime.time.split(":")[0]
                    let currentMinutes: any = serverTime.time.split(":")[1]
                    let CurrentAmOrPm = CurrentHours >= 12 ? 'pm' : 'am';
                    CurrentHours = CurrentHours % 12 || 12;
                    let Currenttime: any = CurrentHours + '' + CurrentAmOrPm;
                    //define hours or minutes
                    var timeStartMin = new Date(
                        '01/01/2007 ' + storeOpenTime,
                    ).getMinutes();
                    var timeEndMin = new Date(
                        '01/01/2007 ' + storeCloseTime,
                    ).getMinutes();
                    var timeStartHours = new Date(
                        '01/01/2007 ' + storeOpenTime,
                    ).getHours();
                    var timeEndHours = new Date(
                        '01/01/2007 ' + storeCloseTime,
                    ).getHours();
                    var hourDiff: any = timeEndHours - timeStartHours;
                    let HourString = HoursArray(hourDiff, timeStartHours);
                    let splitHourArray = HourString.split(":")
                    if (splitHourArray.indexOf(Currenttime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                        if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                            if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                                //if Pick Hour with am/pm is exist in HourString at last index
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.TOP_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            } else {
                                savePickupStore()
                            }
                        } else {
                            if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                                if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                                    if (currentMinutes < timeEndMin) {
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.TOP_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                } else {
                                    savePickupStore()
                                }
                            } else { //if store opening or closing minute is not 00
                                if (
                                    currentMinutes > timeStartMin ||
                                    currentMinutes < timeEndMin
                                ) {
                                    savePickupStore()
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            }
                        }
                    } else {
                        toast.error(t("STORE_CLOSED"), {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                    }
                    return;
                }
            })
        })
    }
    const handleCartRemove = () => {
        props.saveCart([])
        let store: any = pickupStore;
        if (store) {
            if (orderTime == "later") {
                if (store.isDays == 0) {
                    compareLaterOpenClosingTime(store);
                }
                else if (store.isDays == 1) {
                    compareLaterTimingbyEachDay(store)
                }
            } else if (orderTime == "now") {
                if (store.isDays == 0) {
                    compareOpenClosingTime(store)
                } else if (store.isDays == 1) {
                    compareTimingbyEachDay(store, "pickup")
                }
            }
        }
    }
    const cartCloseModal = () => {
        cartShowModal(false)
    }
    const handleClick = () => {
        if (pickupStore?.channel_active) {
            let cart = cartData;
            if (cart && cart.length > 0 && storeSelected) {
                showModal(false);
                // handleCartRemove();
                cartShowModal(true)
            } else {
                let store: any = pickupStore;
                if (store) {
                    if (orderTime == "later") {
                        if (store.isDays == 0) {
                            compareLaterOpenClosingTime(store);
                        }
                        else if (store.isDays == 1) {
                            compareLaterTimingbyEachDay(store)
                        }
                    } else if (orderTime == "now") {
                        if (store.isDays == 0) {
                            compareOpenClosingTime(store)
                        } else if (store.isDays == 1) {
                            compareTimingbyEachDay(store, "pickup")
                        }
                    }
                }
            }
        }
        else toast.error(t("STORE_CLOSED"))

    }
    const pickupOrderReady = () => {
        if (orderTime == "now") {
            return (pickupStore)
        } else {
            return (pickupStore && orderTime == "later" && laterdatetime !== "" && validTimeFlag)
        }
    }
    const { t } = useTranslation();
    return (
        <div>
            <button className={orderType === "Pickup" ? 'order-option option-active' : 'order-option'} onClick={handleShow}>
                <img className='' src={cartoon} alt="" />
                <span onClick={() => { addEvent({ category: "events", events: "Pickup Button" }) }} className='order-title'>{t("PICKUP")}</span>
            </button>

            <Modal show={show} onHide={handleClose} centered backdrop={"static"}>
                <div className='modal-design'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Header className='text-center d-block' closeButton>
                    <Modal.Title className='font-bold h4'>{t("PICKUPYOURORDER")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PickupModal setOrderTime={setOrderTime} orderTime={orderTime} setLaterDate={setLaterDate} laterdatetime={laterdatetime} cities={props.cities} selectStore={selectStore} selectedPickupStore={pickupStore} />
                    <Button disabled={!pickupOrderReady()} style={{ textTransform: 'none', cursor: pickupOrderReady() ? "pointer" : "no-drop", backgroundColor: pickupOrderReady() ? "#e4002b" : "#ea002a75", color: pickupOrderReady() ? "#fff" : "rgb(255 255 255 / 35%)" }} onClick={() => handleClick()} className='m-auto d-flex mt-4 font-medium button-event' variant="contained" color="error">{t("STARTYOURORDER") }</Button>
                </Modal.Body>
            </Modal>
            <Modal className='track-modal border-0' show={open} onHide={cartCloseModal} centered>
                <div className='modal-design'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Body className='p-0'>
                    <div className="px-4 mt-0">
                        <div className="mt-3">
                            <div className='text-center'>
                                <span>
                                    <i className="ri-error-warning-line" style={{ fontSize: "70px", color: "rgba(228, 24, 55, 1)" }}></i>
                                </span>
                                <h5 className='f-w-500 p-1 mb-0'>{t("IFYOUCHANGETHESTORETHECARTWILLRESET")}</h5>
                                <h5 className='f-w-500 p-1'>{t("DOYOUWANTTOCONTINUE")}</h5>
                            </div>
                        </div>
                        <div className='d-flex pb-4 pt-3 justify-content-center gap-10'>
                            <Button variant="contained" color="error" className='confiramtion-btns bg-theme' onClick={() => {
                                handleCartRemove();
                            }}>{t("YES")}</Button>
                            <Button variant="contained" color="error" className='confiramtion-btns bg-theme' onClick={() => cartCloseModal()}>{t("NO")}</Button>
                        </div>
                    </div>
                </Modal.Body>

            </Modal>
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        findPickupStores: function (setState?: any) {
            dispatch(findPickupStores(setState));
        },
        saveStorePosFee: function (fee: number) {
            dispatch(saveStorePosFee(fee));
        },
        saveOrderType: function (type: any) {
            dispatch(saveOrderType(type));
        },
        saveOrderTime: function (type: any) {
            dispatch(saveOrderTime(type));
        },
        saveOrderLaterDateTime: (dateTime: any) => {
            dispatch(saveOrderLaterDateTime(dateTime));
        },
        saveSelectStoreId: (store: any) => {
            dispatch(saveSelectStoreId(store));
        },
        getTimezone: function (id: number) {
            return dispatch(getTimezone(id))
        },
        getTimezoneForLater: function (id: number) {
            return dispatch(getTimezoneForLater(id))
        },
        storeMenuItemCall: (store_id: any, orderType: any,pathname:string,locale:string) => {
            dispatch(storeMenuItemCall(store_id, orderType,pathname,locale))
        },
        saveCart: function (cart: any[]) {
            dispatch(saveCart(cart));
        }
    }
}
export default connect(null, mapDispatchToProps)(PickUp);